// extracted by mini-css-extract-plugin
export default {"button":"K8W2","title":"TZbD","icon":"o_v2","content":"IHxS","expanded":"yMoN"};